import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'

type Props = {}

export const ProjectEmailTooltipContent: FC<Props> = () => {
  return (
    <Txt sizeType="s">
      お客様へ送信するメールアドレスを指定できます。
      <br />
      ご利用になりたい場合は<b>スタイルポート問い合わせ窓口までお問い合わせください。</b>
      <br />
      未設定の場合はnoreply@roov.spaceから送信されます。
    </Txt>
  )
}
